import React, {useCallback, useEffect, useState, useRef} from "react";
import './RadionicaComponent.scss';
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

type RadionicaData = {
    id: string;
    icon: string;
    title: string;
    paragraph1: string;
    paragraph2: string;
    trajanjeParagraph: string;
    carouselImages: string[];
};

type Props = {
    data: RadionicaData;
}

const RadionicaComponent: React.FC<Props> = ( {data} ) => {

    const [emblaRef, emblaApi] = useEmblaCarousel({loop: true}, [Autoplay({delay: 4000})]);
    const [currentImage, setCurrentImage] = useState(0);
    const imageCountRef = useRef(0);

    const scrollPrev = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollPrev();
        //decreaseImageCounter();
      }, [emblaApi])
    
    const scrollNext = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollNext();
        //increaseImageCounter();
    }, [emblaApi])

    const onSelect = useCallback(() => {
        //increaseImageCounter();
        if (!emblaApi){
            //console.log("error no embla");
            return;
        }
        imageCountRef.current = emblaApi.selectedScrollSnap();

        //console.log("index je " + index);
    }, [emblaApi])

    // const increaseImageCounter = () => {
    //     let temp = imageCountRef.current;
    //     temp++;
    //     temp = temp > (data.carouselImages.length - 1) ? 0 : temp;
    //     imageCountRef.current = temp;

    //     console.log("promenio na " + imageCountRef.current);
    // }

    // const decreaseImageCounter = () => {
    //     let temp = imageCountRef.current;
    //     temp--;
    //     temp = temp < 0 ? (data.carouselImages.length - 1) : temp;
    //     imageCountRef.current = temp;

    //     console.log("promenio na " + imageCountRef.current);
    // }

    useEffect(() => {
        if (!emblaApi) return;

        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('select', onSelect);
        }
        
    }, [emblaApi, onSelect])

    const OpenFullImage = () => {
        window.open(data.carouselImages[imageCountRef.current], "_blank");
    }

    return (
        <div className="radionica-container" id={'scrollElement' + data.id}>
            <div className="radionica-title-container">
                <img src={data.icon} alt="icon" className="radionica-icon"/>
                <h1>{data.title}</h1>
            </div>
            <div className="radionica-paragraph-div">
                <h2>Kome je namenjena radionica i koji je cilj?</h2>
                <p>{data.paragraph1}</p>
            </div>
            <div className="radionica-paragraph-div">
                <h2>Kakav je koncept radionice?</h2>
                <p>{data.paragraph2}</p>
                <p><span className="radionica-bold">Trajanje radionice: </span>{data.trajanjeParagraph}</p>
            </div>
            <div className={'radovi-container' + (data.carouselImages.length === 0 ? ' no-radovi' : '')}>
                <h2>Radovi učesnika</h2>
                <div className='carousel-container'>
                    <div className="previous-button desktop-sliders" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className='embla' ref={emblaRef}>
                        <div className="embla__container">
                            {data.carouselImages.map((img, i) => (
                                <div key={i} className="embla__slide">
                                    <img src={img} alt="Slika rada" className='carousel-image' loading="lazy"/>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="next-button desktop-sliders" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="ofi-container">
                    <a onClick={OpenFullImage} id="full-image-preview">Otvori celu sliku</a>
                </div>
                <div className="sliders-for-mobile">
                    <div className="previous-button" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="next-button" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RadionicaComponent;